<template>
  <div>
    <footer class="no-print">
      <CFooter>
        <div class="no-print">
          <a href="https://arboran.com.br" target="_blank"> Arboran </a>
          <span class="ml-1">&copy; 2021</span>
        </div>

        <div class="ml-auto no-print">
          <span class="mr-1">Desenvolvido por</span>
          <a href="https://arboran.com.br" target="_blank">Arboran</a>
        </div>
      </CFooter>
    </footer>
  </div>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>


<style scoped>
#footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background-color: #ccc;
}

.table {
  border-collapse: collapse;
  /* border: 1px solid black; */
  /* display: none; */
}

th,
td {
  /* border: 1px solid black; */
  padding: 8px;
  text-align: left;
}
</style>